import React from "react";
import "./FeaturesSection.css";

import {
    FaShieldAlt,
    FaRupeeSign,
    FaTruck,
    FaGlobe,
    FaHandshake,
    FaMapMarkerAlt
} from "react-icons/fa";

const features = [
    {
        icon: <FaShieldAlt />,
        title: "Verified & Trusted",
        description:
            "All sellers and products are carefully reviewed to ensure quality, authenticity, and transparency.",
    },
    {
        icon: <FaMapMarkerAlt />,
        title: "Truly Hyperlocal",
        description:
            "Shop from trusted stores and sellers in your area — supporting local livelihoods and getting fresher deliveries.",
    },
    {
        icon: <FaRupeeSign />,
        title: "No Hidden Fees",
        description:
            "Clear, upfront pricing for buyers and sellers. No surprises at checkout, no extra charges.",
    },
    {
        icon: <FaTruck />,
        title: "Quick, Local Delivery",
        description:
            "Enjoy fast shipping and fresh products from nearby sellers, with extra care for ritual and Satvik items.",
    },
    {
        icon: <FaGlobe />,
        title: "Mindful Shopping",
        description:
            "A curated collection of Satvik foods, organic staples, pooja essentials, and spiritual books for your conscious lifestyle.",
    },
    {
        icon: <FaHandshake />,
        title: "Ethical Commerce",
        description:
            "We connect you with sellers who value honesty, quality, and tradition—so you can shop with peace of mind.",
    },
];

const FeaturesSection = () => {
    return (
        <section className="features-section-container section-margin-top-common">
            <div className="features-section-content">
                <h2 className="_hTitle_s5E_ features-title">What Makes Vanidya Unique?</h2>
                <div className="features-flex-container">
                    {features.map((feature, index) => (
                        <div key={index} className="feature-item">
                            <div className="feature-icon">{feature.icon}</div>
                            <h4 className="feature-title-text">{feature.title}</h4>
                            <p className="feature-description">{feature.description}</p>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default FeaturesSection;